"use strict";
export const DeviceMock = (mock) => {
  mock.onGet("/api/v7/account/device_info").reply((config) => {
    let response = {
      "model": "grid.result",
      "result": {
        "model": "data.set",
        "datas": [
          {
            "model": "deivce.info",
            "guid": "0b6c9cb580804708b950353b6fa9784d",
            "create_time": 1620801024e3,
            "mini": "fe72f774a6",
            "mac": "3C-7C-3F-29-47-DA",
            "device_name": "windows-x64_fcab(2021-5-12)",
            "last_login_time": 1620974685e3,
            "verify_time": 1620869844e3
          },
          {
            "model": "deivce.info",
            "guid": "2ac241aa7d0e46d0893bbf557156806c",
            "create_time": 1619667377e3,
            "mini": "64316ba595",
            "mac": "3C-7C-3F-29-47-DA",
            "device_name": "darwin-x64_e102(4-29-2021)",
            "last_login_time": 1621248258e3,
            "verify_time": 1619672504e3
          },
          {
            "model": "deivce.info",
            "guid": "f89c7cedefb34939a6a51ad7c33e0530",
            "create_time": 161976843e4,
            "mini": "9ad9a6742c",
            "mac": "3C-7C-3F-29-47-DA",
            "device_name": "windows-x64_8c55(2021-4-30)",
            "last_login_time": 1619768442e3,
            "verify_time": 1619768442e3
          },
          {
            "model": "deivce.info",
            "guid": "85cbba1a8d8c41dea6a576bba1705b2a",
            "create_time": 1619677089e3,
            "mini": "157e9818ab",
            "mac": "3C-7C-3F-29-47-DA",
            "device_name": "windows-x64_25a3(2021-4-29)",
            "last_login_time": 1621329678e3,
            "verify_time": 1619677106e3
          }
        ],
        "total": 4
      },
      "page": {
        "model": "page",
        "current": 1,
        "total": 4,
        "size": 10
      }
    };
    return [200, response];
  });
};
